module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-Book.e65584ac.woff2";